<div class="flex flex-col pl-[34px] pr-[17px] sm:pl-[77px] sm:pr-[77px]
bg-opacity-10 bg-naranja rounded-[18px] pt-[47px] pb-[47px] sm:pt-[69px] sm:pb-[91px]
justify-center items-center text-center
">
<ln-empty-shopping-cart [class]="'z-20 w-[50px] h-[50px] sm:w-[65px] sm:h-[65px]'"></ln-empty-shopping-cart>
  <div class="text-cafe text-base sm:text-xl font-semibold mt-[10px]">{{'messages.yourCartIsEmpty' | transloco}}</div>
</div>
